import { PublicLayout } from "@/components/PublicLayout";
import { ValutaForm } from "@/components/LeadForms";
import { useSeo } from "@/lib/useSeo";
import { CheckCircle2, Phone } from "lucide-react";

export default function ValutaCasa() {
  useSeo({
    title: "Valuta la tua casa gratis a Scandicci e Firenze | Edilstudio",
    description: "Richiedi la valutazione gratuita e senza impegno del tuo immobile a Scandicci o Firenze. Stima professionale basata su dati OMI e conformità urbanistica verificata.",
    canonicalPath: "/valuta-la-tua-casa",
  });
  return (
    <PublicLayout>
      <section className="grid lg:grid-cols-2">
        <div className="bg-[#1B2A41] text-white px-6 sm:px-10 lg:px-16 py-16 lg:py-24">
          <p className="eyebrow text-[#F5A623]">Per proprietari venditori</p>
          <h1 className="font-display text-4xl lg:text-5xl font-bold mt-3 leading-tight">Fai valutare la tua casa</h1>
          <p className="text-white/80 mt-5 leading-relaxed max-w-md">Ricevi una stima professionale del tuo immobile, gratuita e senza impegno. Analizziamo i dati OMI, il transato reale della zona e la conformità urbanistica.</p>
          <ul className="mt-8 space-y-4">
            {["Valutazione gratuita e senza impegno", "Basata su transato reale a Scandicci/Firenze", "Conformità urbanistica verificata dallo studio tecnico", "Risposta entro 24 ore lavorative"].map((t) => (
              <li key={t} className="flex items-start gap-3"><CheckCircle2 className="w-5 h-5 text-[#F5A623] mt-0.5 shrink-0" /><span className="text-white/85">{t}</span></li>
            ))}
          </ul>
          <div className="mt-10 pt-8 border-t border-white/10">
            <p className="text-sm text-white/60">Preferisci parlarne di persona?</p>
            <a href="tel:0555277501" className="inline-flex items-center gap-2 mt-3 text-white font-semibold text-lg hover:text-[#6FB3EC] transition-colors"><Phone className="w-5 h-5 text-[#6FB3EC]" /> 055 5277501</a>
            <p className="text-sm text-white/50 mt-2">Via Salvador Allende 14/c, Scandicci (FI) · Lun–Ven 9–13 / 15–19</p>
          </div>

        </div>
        <div className="px-6 sm:px-10 lg:px-16 py-16 lg:py-24 bg-[#F7FAFC]">
          <div className="bg-white rounded-2xl border border-[#DCE6EF] p-6 sm:p-8">
            <h2 className="font-display text-2xl font-bold text-[#1B2A41]">Richiedi la valutazione</h2>
            <p className="text-sm text-[#566476] mt-1 mb-6">Compila i dati: ti ricontattiamo noi.</p>
            <ValutaForm />
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
